<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-alert
          border="left"
          colored-border
          elevation="2"
          type="success"
        >Общая площадь активных территорий: {{ billing.active_area }} km2 / {{ billing.active_area * 100 }} ha | Общая площадь заказанных территорий: {{ billing.order_area }} km2 / {{ billing.order_area * 100 }} ha | Всего (заказы + активные): {{ billing.total_area }} km2 / {{ billing.total_area * 100 }} ha | Максимальная площадь по договору: {{ billing.max_area }} km2 / {{ billing.max_area * 100}} ha</v-alert>
      </v-col>
    </v-row>
    <v-row>
      <!-- presets -->
      <v-col>
        <wapi-panel :title="'Фильтр'">
          <template v-slot:toolbar>
            <span v-if="userId">
              Заказы территорий для
              <kbd>{{ userName }}</kbd>.
            </span>
          </template>
          <template v-slot:content>
            <managed-presets :userId="userId" :pvariants="pvariants" :predicts="predicts" />
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../models/contract/WapiContract";
import { areaInKm2 } from "../helpers/common";
import ManagedPresets from "../components/ManagedPresets.vue";
import WapiPanel from "../components/WapiPanel";

export default {
  name: "PresetsView",
  title: "Территории",
  components: {
    ManagedPresets,
    WapiPanel
  },
  async created() {
    this.$store.dispatch("SET_LOADING", true);

    try {
      this.billing = await this.$store.dispatch("FETCH_USER_BILLING_AREA");
      this.contract = await this.$store.dispatch("FETCH_CONTRACT_INFO");
      this.coordinateOrder = this.contract.preset_settings.coordinate_order;
      this.userId = this.$store.getters.USER.id;
    } catch (err) {
      this.$store.dispatch("PUSH_ERROR", err);
    }

    this.$store.dispatch("SET_LOADING", false);
  },
  data: function() {
    return {
      billing: {},
      page: 1,
      paginationTotalVisible: 10,
      perPage: 6,
      pvariants: [],
      dvariant: null,
      presets: [],
      contract: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          const mapId = this.pagePresets.findIndex(
            x => x.area.id === feature.id
          );
          this.$refs.maps[mapId].mapObject.fitBounds(bounds);
        }
      },
      dvariants: [],
      predicts: [],
      userId: "",
      presetId: "",
      result: [],
      coordinateOrder: []
    };
  },
  computed: {
    paginationLength() {
      return Math.ceil(this.presets.length / this.perPage);
    },
    pagePresets() {
      const from = (this.page - 1) * this.perPage;
      const to = this.page * this.perPage;
      return this.presets.slice(from, to);
    },
    pagination() {
      return !!this.pagePresets.length;
    },
    userName() {
      if (!this.userId) return "";
      if (this.isAdmin) {
        return this.users.find(x => x.id === this.userId).name;
      }

      return this.$store.getters.USER.name;
    },
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    },
    totalAreaInKm() {
      const reducer = (accumulator, currentValue) =>
        accumulator + Math.round(areaInKm2(currentValue.geoJson.geometry));
      return this.pagePresets.reduce(reducer, 0);
    },
    totalAreaInHa() {
      const reducer = (accumulator, currentValue) =>
        accumulator + Math.round(areaInKm2(currentValue.geoJson.geometry));
      return this.pagePresets.reduce(reducer, 0);
    }
  },
  methods: {
    areaInKm(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry) / 1000000);
      return area;
    },
    areaInHa(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry) / 10000);
      return area;
    },
    openPreset(preset) {
      this.$router.push({
        name: "PRESET_DETAILS",
        params: { userId: preset.user_id, presetId: preset.id }
      });
    },
    deletePreset() {},
    async onChangePreset() {
      const preset = this.presets.find(p => p.id === this.presetId);
      this.geojson = preset.geoJson;
    },
    reset() {
      this.page = 1;
    }
  }
};
</script>